import script from "./PageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContainer.vue?vue&type=script&setup=true&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=12add5da&lang=scss"
import "./PageContainer.vue?vue&type=style&index=1&id=12add5da&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./PageContainer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12add5da"]])

export default __exports__